"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var provide_decorator_factory_1 = require("./factory/provide_decorator_factory");
exports.makeProvideDecorator = provide_decorator_factory_1.default;
var fluent_provide_decorator_factory_1 = require("./factory/fluent_provide_decorator_factory");
exports.makeFluentProvideDecorator = fluent_provide_decorator_factory_1.default;
var auto_wire_1 = require("./utils/auto_wire");
exports.autoProvide = auto_wire_1.default;



//////////////////
// WEBPACK FOOTER
// ./node_modules/inversify-binding-decorators/lib/index.js
// module id = 1172
// module chunks = 0